// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".disabled[data-v-7d5b46dd] {\n  background-color: #d5d5da !important;\n}\n.accepted-cards[data-v-7d5b46dd] {\n  display: flex;\n}\n@media (max-width: 1024px) {\n.wizard-form-container[data-v-7d5b46dd] {\n    width: 80%;\n    margin: 0 auto;\n    flex-direction: column;\n}\n.wizard-form-container .wizard-form .wizard-article[data-v-7d5b46dd]:nth-child(2) {\n    display: none;\n}\n}\n@media (max-width: 640px) {\n.wizard-form-container[data-v-7d5b46dd] {\n    width: 100%;\n}\n}", ""]);
// Exports
module.exports = exports;
